import React, { useEffect } from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import Achievements from "./Achievements";
import Skills from "./Skills";
import Experience from "./Experience";
import Projects from "./Projects";
import Certificates from "./Certificates";
import Education from "./Education";
import Contact from "./Contact";
import Footer from "./Footer";
import MouseFollower from "./MouseFollower";

export default function Portfolio() {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    document.documentElement.classList.add("light");
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900 font-sans selection:bg-indigo-600 selection:text-white transition-colors duration-300 relative">
      {/* Desktop Mouse Aura Follower */}
      <MouseFollower />

      {/* Sticky Glassmorphic Navbar */}
      <Navbar />

      {/* Main Content Sections */}
      <main className="relative z-10 space-y-4">
        <Hero />
        <About />
        <Services />
        <Achievements />
        <Skills />
        <Experience />
        <Projects />
        <Certificates />
        <Education />
        <Contact />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}